import FundInvestmentProfile from './FundInvestmentProfile'

export default FundInvestmentProfile
